var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27778 2.28571L9.94444 10M22.7222 2.28571L15.0556 10M9.94444 10L10.693 10.7532C11.691 11.7574 13.309 11.7574 14.3071 10.7532L15.0556 10M9.94444 10L2.12276 17.8703M15.0556 10L22.8772 17.8703M22.8772 17.8703C23.5709 17.1723 24 16.208 24 15.1429V3.57143C24 2.15127 22.8558 1 21.4444 1H3.55556C2.14416 1 1 2.15127 1 3.57143V15.1429C1 16.208 1.42906 17.1723 2.12276 17.8703M22.8772 17.8703C22.1835 18.5683 21.2252 19 20.1667 19H4.83333C3.77479 19 2.81645 18.5683 2.12276 17.8703",
    stroke: "#73E893",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMsg);
export default __webpack_public_path__ + "static/media/login-msg.dcb74dfa215d8c70adef1425b178f837.svg";
export { ForwardRef as ReactComponent };